import { render } from "./TrendChart.vue?vue&type=template&id=648b4c18&scoped=true"
import script from "./TrendChart.vue?vue&type=script&lang=js"
export * from "./TrendChart.vue?vue&type=script&lang=js"

import "./TrendChart.vue?vue&type=style&index=0&id=648b4c18&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648b4c18"]])

export default __exports__